import React from "react";

import { useGetCarbonProgramByFarmId } from "utils";

import { CropFCPO, FieldPracticeResponse, FieldVerification, PRACTICE_SLUG, PracticeFCPO } from "models";

import { AddEditCropDrawer } from "pages/app/all-field-view/components/AddEditCropDrawer";

export const CropDrawer = ({
  crop,
  fieldPractices,
  field,
  farmId,
  showDrawer,
  onClose,
}: {
  crop: CropFCPO | null;
  fieldPractices: FieldPracticeResponse | undefined;
  field: FieldVerification;
  farmId: string;
  showDrawer: boolean;
  onClose: () => void;
}) => {
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);

  if (!crop || !fieldPractices) {
    return;
  }

  const filterByCropId = (practice: PracticeFCPO): boolean => crop.id.toString().includes("UNKNOWN") || practice.cropId === crop.id;

  const existingFertilizers =
    fieldPractices.practices.filter(
      (practice) => (practice.type === PRACTICE_SLUG.MINERAL_FERTILIZERS || practice.type === PRACTICE_SLUG.ORGANIC_FERTILIZERS) && filterByCropId(practice)
    ) ?? [];

  const existingTillages = fieldPractices.practices?.filter((practice) => practice.type === PRACTICE_SLUG.TILLAGES && filterByCropId(practice)) ?? [];

  return (
    <AddEditCropDrawer
      existingCrop={crop}
      availablePracticeBundles={fieldPractices.availablePracticeBundles}
      field={{
        ...field,
        isInRedzone: !!field.redzone && field.redzone?.confirmed !== false,
        location: field.location!,
        redzones: [], // redzones array is not needed in the drawer
      }}
      showDrawer={showDrawer}
      setShowDrawer={onClose}
      existingFertilizers={existingFertilizers}
      existingTillages={existingTillages}
      allCrops={fieldPractices.crops}
      year={crop.year!}
      fertilizerManagements={fieldPractices.fertilizerManagements}
      farmId={farmId}
      carbonProgram={carbonProgram}
    />
  );
};
